import type { EntityType } from '@app/types/EntityType'

import { DEFAULT_LANGUAGE, LISTING_SLUGS, PROJECT_SLUGS } from './constants'

type SlugLookup = Record<EntityType, Partial<Record<string, string[]>>>

const SLUGS_BY_ENTITY: SlugLookup = {
  listing: LISTING_SLUGS,
  project: PROJECT_SLUGS,
}

const ensureLanguageKey = (value?: string) => {
  if (!value) {
    return undefined
  }

  return value.split('-')[0]?.toLowerCase()
}

export const getEntitySlug = (
  type: EntityType,
  culture?: string,
  language?: string
) => {
  const lookup = SLUGS_BY_ENTITY[type]
  const candidates = [
    ensureLanguageKey(culture),
    ensureLanguageKey(language),
    DEFAULT_LANGUAGE,
  ]

  for (const candidate of candidates) {
    if (!candidate) {
      continue
    }

    const slugs = lookup[candidate]
    if (slugs && slugs.length > 0) {
      return slugs[0]
    }
  }

  const defaultSlugs = lookup[DEFAULT_LANGUAGE]
  if (defaultSlugs && defaultSlugs.length > 0) {
    return defaultSlugs[0]
  }

  return type
}
